var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5087 5.1989C15.8131 5.47985 15.8321 5.95435 15.5511 6.25871L10.0207 12.25L15.5511 18.2413C15.8321 18.5457 15.8131 19.0202 15.5087 19.3011C15.2043 19.5821 14.7299 19.5631 14.4489 19.2587L8.4489 12.7587C8.1837 12.4714 8.1837 12.0286 8.4489 11.7413L14.4489 5.24129C14.7299 4.93693 15.2043 4.91795 15.5087 5.1989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.6c7140dc9ce37f25cd10d03c15da6db1.svg";
export { ForwardRef as ReactComponent };